var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2974 4.88802V12.2214H8.46403V4.88802H5.71403L9.3807 0.304688L13.0474 4.88802L10.2974 4.88802ZM3.88069 3.97135V6.45369C2.94722 7.51215 2.33899 8.81748 2.129 10.2131C1.919 11.6086 2.11616 13.0351 2.69682 14.3214C3.27747 15.6077 4.21696 16.6992 5.40253 17.4647C6.58811 18.2303 7.96941 18.6376 9.3807 18.6376C10.792 18.6376 12.1733 18.2303 13.3589 17.4647C14.5444 16.6992 15.4839 15.6077 16.0646 14.3214C16.6452 13.0351 16.8424 11.6086 16.6324 10.2131C16.4224 8.81748 15.8142 7.51215 14.8807 6.45369V3.97135C16.0197 4.82471 16.9441 5.93179 17.5806 7.20474C18.2171 8.4777 18.5481 9.88148 18.5474 11.3047C18.5474 16.3674 14.4434 20.4714 9.3807 20.4714C4.31795 20.4714 0.214027 16.3674 0.214027 11.3047C0.213316 9.88148 0.544333 8.4777 1.18081 7.20474C1.81729 5.93179 2.7417 4.82471 3.88069 3.97135Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutButton);
export default __webpack_public_path__ + "static/media/logout_button.44dd6dd5aa17426492d40300926ba928.svg";
export { ForwardRef as ReactComponent };